/*
 * GDP 2026-09-26 : menu mobile, rails produits deroulants.
 * Les entrees Nos miels, Nos amandes et Nos coffrets du tiroir #sidebar-menu
 * s ouvrent sur place (accordeon exclusif) au lieu de naviguer vers la collection.
 * Le clic est intercepte en phase de capture pour que le gestionnaire du theme
 * (sous-panneau lateral) ne se declenche pas sur ces boutons.
 */
(() => {
  const root = document.getElementById('sidebar-menu');
  if (!root || root.hasAttribute('data-gdp-mp-ready')) return;
  root.setAttribute('data-gdp-mp-ready', '');

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const groups = () => Array.from(root.querySelectorAll('[data-gdp-mp]'));
  const partsOf = (group) => ({
    button: group.querySelector('.gdp-mp__toggle'),
    panel: group.querySelector('.gdp-mp__panel'),
    rail: group.querySelector('.gdp-mp__rail'),
    track: group.querySelector('.gdp-mp__track')
  });

  const warm = (group, count) => {
    const imgs = group.querySelectorAll('.gdp-mp__media img[loading="lazy"]');
    for (let i = 0; i < imgs.length && i < count; i += 1) imgs[i].loading = 'eager';
  };

  const updateProgress = (group) => {
    const { rail, track } = partsOf(group);
    if (!rail || !track) return;
    const max = rail.scrollWidth - rail.clientWidth;
    if (max <= 2) {
      track.hidden = true;
      return;
    }
    track.hidden = false;
    const trackWidth = track.clientWidth;
    const thumb = Math.max(20, trackWidth * (rail.clientWidth / rail.scrollWidth));
    const x = (trackWidth - thumb) * Math.min(1, Math.max(0, rail.scrollLeft / max));
    track.style.setProperty('--gdp-mp-thumb', `${thumb.toFixed(1)}px`);
    track.style.setProperty('--gdp-mp-x', `${x.toFixed(1)}px`);
  };

  const reveal = (group) => {
    const scroller = group.closest('.header-sidebar__scroller');
    const panel = group.querySelector('.gdp-mp__panel');
    if (!scroller || !panel) return;
    let done = false;
    const run = () => {
      if (done) return;
      done = true;
      panel.removeEventListener('transitionend', onEnd);
      if (!group.classList.contains('is-open')) return;
      const box = group.getBoundingClientRect();
      const view = scroller.getBoundingClientRect();
      const overflow = box.bottom - view.bottom + 16;
      if (overflow <= 0) return;
      const room = box.top - view.top - 8;
      const delta = Math.min(overflow, room);
      if (delta <= 0) return;
      scroller.scrollTo({ top: scroller.scrollTop + delta, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    };
    const onEnd = (event) => {
      if (event.target === panel && event.propertyName === 'grid-template-rows') window.setTimeout(run, 40);
    };
    if (reduceMotion.matches) {
      window.requestAnimationFrame(run);
      return;
    }
    panel.addEventListener('transitionend', onEnd);
    window.setTimeout(run, 560);
  };

  const setOpen = (group, open, options = {}) => {
    const { button, panel, rail } = partsOf(group);
    if (!button || !panel) return;
    if (group.classList.contains('is-open') === open) return;
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      panel.removeAttribute('inert');
      warm(group, 4);
      group.classList.remove('is-entering');
      group.classList.add('is-open');
      if (!reduceMotion.matches) {
        void group.offsetWidth;
        group.classList.add('is-entering');
        window.setTimeout(() => group.classList.remove('is-entering'), 1400);
      }
      window.requestAnimationFrame(() => updateProgress(group));
      if (options.reveal !== false) reveal(group);
    } else {
      group.classList.remove('is-open', 'is-entering');
      panel.setAttribute('inert', '');
      if (options.resetScroll && rail) rail.scrollLeft = 0;
    }
  };

  root.addEventListener('click', (event) => {
    const button = event.target.closest('.gdp-mp__toggle');
    if (!button || !root.contains(button)) return;
    event.stopPropagation();
    event.preventDefault();
    const group = button.closest('[data-gdp-mp]');
    const willOpen = !group.classList.contains('is-open');
    groups().forEach((other) => {
      if (other !== group) setOpen(other, false, { resetScroll: true });
    });
    setOpen(group, willOpen);
  }, true);

  root.addEventListener('pointerdown', (event) => {
    const button = event.target.closest('.gdp-mp__toggle');
    if (button) warm(button.closest('[data-gdp-mp]'), 4);
  }, { passive: true });

  groups().forEach((group) => {
    const { rail } = partsOf(group);
    if (!rail) return;
    let frame = 0;
    rail.addEventListener('scroll', () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        updateProgress(group);
      });
    }, { passive: true });
  });

  root.addEventListener('dialog:before-show', () => {
    groups().forEach((group) => warm(group, 2));
    // 08/10/2026 (Tomi) : « Nos coffrets » est deja ouvert a chaque ouverture du menu : le client voit tout de suite
    // qu on choisit en images, et les coffrets sont a un toucher. Les autres entrees restent repliees (accordeon exclusif).
    const first = root.querySelector('[data-gdp-mp].gdp-mp--coffrets') || groups()[0];
    if (!first) return;
    groups().forEach((group) => { if (group !== first) setOpen(group, false, { resetScroll: true }); });
    setOpen(first, true, { reveal: false });
    window.setTimeout(() => updateProgress(first), 450);
  });
  root.addEventListener('dialog:after-hide', () => {
    groups().forEach((group) => setOpen(group, false, { resetScroll: true }));
  });
  window.addEventListener('resize', () => {
    groups().forEach((group) => {
      if (group.classList.contains('is-open')) updateProgress(group);
    });
  }, { passive: true });
})();
